import { useState } from 'react'
import type { KbSource } from '@rp/contracts'
import { isApiError } from '../../api/client'
import { useReadySession } from '../../session/useSession'
import { KB_COPY } from './copy'
import { downloadKbSource } from './queries'

const messageOf = (error: unknown): string => (isApiError(error) ? error.message : KB_COPY.downloadFailed)

const withId = (ids: ReadonlySet<string>, id: string): ReadonlySet<string> => new Set([...ids, id])

const withoutId = (ids: ReadonlySet<string>, id: string): ReadonlySet<string> =>
  new Set([...ids].filter((entry) => entry !== id))

const withoutKey = (errors: ReadonlyMap<string, string>, id: string): ReadonlyMap<string, string> =>
  new Map([...errors].filter(([key]) => key !== id))

export const useKbDownload = () => {
  const { api } = useReadySession()
  const [downloadingIds, setDownloadingIds] = useState<ReadonlySet<string>>(new Set())
  const [downloadErrors, setDownloadErrors] = useState<ReadonlyMap<string, string>>(new Map())

  const onDownload = (source: Pick<KbSource, 'id' | 'title'>) => {
    setDownloadingIds((ids) => withId(ids, source.id))
    setDownloadErrors((errors) => withoutKey(errors, source.id))
    downloadKbSource(api, source)
      .catch((error: unknown) => setDownloadErrors((errors) => new Map([...errors, [source.id, messageOf(error)]])))
      .finally(() => setDownloadingIds((ids) => withoutId(ids, source.id)))
  }

  return { onDownload, downloadingIds, downloadErrors }
}
